import type { CardSliderItem } from 'app/components/card-slider';
import { images } from 'app/design/images';
import { Text } from 'app/design/primitives/text';
import { getI18nLanguage } from 'app/lib/language';

import { Trans } from 'react-i18next';

export enum PresentPartageClubCarouselStep {
  Community = 'community',
  AccessMore = 'accessMore',
  OfferMore = 'offerMore',
}

const HEADER_TEXT_STYLE = { fontSize: 24, fontWeight: '700', color: 'white' } as const;
const FOOTER_TEXT_STYLE = { fontSize: 20, fontWeight: '700', color: 'white' } as const;

export function usePresentPartageClubCarouselItems(): CardSliderItem[] {
  return (() => {
    const items: CardSliderItem[] = [];
    const i18nLanguage = getI18nLanguage();

    // @TODO Customize for other SaaS, if we enable the useNewOnboarding FeatureFlag for anyone else than Partage Club

    items.push({
      id: PresentPartageClubCarouselStep.Community,
      topText: (
        <Trans
          components={{ strong: <Text {...HEADER_TEXT_STYLE} /> }}
          i18nKey={`${PresentPartageClubCarouselStep.Community}.headerText`}
          ns="presentPartageClub"
        />
      ),
      image: i18nLanguage === 'fr' ? images.onboarding.communityFr : images.onboarding.communityEn,
      bottomText: (
        <Trans
          components={{ strong: <Text {...FOOTER_TEXT_STYLE} /> }}
          i18nKey={`${PresentPartageClubCarouselStep.Community}.footerText`}
          ns="presentPartageClub"
        />
      ),
      backgroundImage: images.onboarding.communityBg,
    });
    items.push({
      id: PresentPartageClubCarouselStep.AccessMore,
      topText: (
        <Trans
          components={{ strong: <Text {...HEADER_TEXT_STYLE} /> }}
          i18nKey={`${PresentPartageClubCarouselStep.AccessMore}.headerText`}
          ns="presentPartageClub"
        />
      ),
      image: i18nLanguage === 'fr' ? images.onboarding.accessMoreFr : images.onboarding.accessMoreEn,
      bottomText: (
        <Trans
          components={{ strong: <Text {...FOOTER_TEXT_STYLE} /> }}
          i18nKey={`${PresentPartageClubCarouselStep.AccessMore}.footerText`}
          ns="presentPartageClub"
        />
      ),
      backgroundImage: images.onboarding.accessMoreBg,
    });
    items.push({
      id: PresentPartageClubCarouselStep.OfferMore,
      topText: (
        <Trans
          components={{ strong: <Text {...HEADER_TEXT_STYLE} /> }}
          i18nKey={`${PresentPartageClubCarouselStep.OfferMore}.headerText`}
          ns="presentPartageClub"
        />
      ),
      image: i18nLanguage === 'fr' ? images.onboarding.offerMoreFr : images.onboarding.offerMoreEn,
      bottomText: (
        <Trans
          components={{ strong: <Text {...FOOTER_TEXT_STYLE} /> }}
          i18nKey={`${PresentPartageClubCarouselStep.OfferMore}.footerText`}
          ns="presentPartageClub"
        />
      ),
      backgroundImage: images.onboarding.offerMoreBg,
    });

    return items;
  })();
}
